import * as React from 'react';
import { Box, Chip, IconButton, Paper, Stack, Typography } from '@mui/material';
import { PencilSimple as PencilSimpleIcon } from '@phosphor-icons/react';
import { toTitleCase } from '@/lib/v2/typography/to-title-case';

interface AccountRoleCardProps {
  accountUsers: Array<{ id: number | string; role?: { name?: string } | null }> | undefined;
  isArchived: boolean;
  onEdit: () => void;
}

export function AccountRoleCard({ accountUsers, isArchived, onEdit }: AccountRoleCardProps): React.JSX.Element {
  const hasRole = (accountUsers ?? []).some((au) => au.role?.name);

  return (
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <Box
        sx={{
          p: { xs: 2, md: 3 },
          borderBottom: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Account Role
        </Typography>
        {!isArchived && (
          <IconButton onClick={onEdit} size="small">
            <PencilSimpleIcon size={18} />
          </IconButton>
        )}
      </Box>
      <Box sx={{ p: 2 }}>
        {hasRole ? (
          <Stack spacing={1}>
            {(accountUsers ?? []).map((accountUser) => (
              <Box key={accountUser.id}>
                {accountUser.role ? (
                  <Chip label={toTitleCase(accountUser.role.name ?? '')} size="medium" color="info" />
                ) : null}
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography color="text.secondary" variant="body2">
            No account role assigned
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
